<template>
    <li v-if="userAccessible" ref="actionLink" :class="classAttr">
        <a :id="linkId" class="nav-link" href="#" @click.prevent="onActionClick">
            <FontAwesomeIcon :icon="linkIcon" />
            <span class="link-label">{{item.label}}</span>
            <b-badge v-if="item.badge && item.badge.text" :variant="item.badge.variant">{{item.badge.text}}</b-badge>
        </a>
    </li>
</template>

<script>
    export default {
        name: "SidebarNavAction",
        props: {
            linkId: { type: String, default: () => { return _.uniqueId("sb-nav-link-"); } },
            item: { type: Object, required: true, default: () => {} }
        },
        computed: {
            linkIcon() { return this.item.icon; },
            userAccessible () {
                // if (!_.isString(this.item.accessKey) || !this.securitySettings) return true;
                // return this.securitySettings.findValue(this.item.accessKey) !== UserScreenAccessLevel.None;
                return true;
            },
            classAttr() { return `nav-item level-${this.item.level} theme-${this.item.theme}`; }
        },
        methods:{
            onActionClick(e){
                // GlobalEventManager.fireAction(this.item.action);
            }
        }
    };
</script>
